import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import ModalWrapper from './ModalWrapper';
import { FAILED_FAX_VISIBILITY_FEATURE, verifyFeatureAccess } from '../../global/featureFlags';

class ResendRecord extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      params: this.props.modalType.data,
      conflictMessage: null,
    };
  }

  /*
   * Resends records to the recipients. If the recipient is a fax number, it will
   * send a new access code page. If the recipient is a Medsender User, they will
   * simply receive a new email notification of record received.
   */
  resend = async () => {
    const {
      recipient, days, source, onResent,
    } = this.state.params;
    const { isBulkResend, resendRecord, bulkResend } = this.props;
    if (isBulkResend) {
      await bulkResend(days);
    } else {
      // ENG-3340: with the feature on, never replay a resend on 503, and explain a
      // 409 (still being sent) here instead of reporting success.
      const guarded = await verifyFeatureAccess(FAILED_FAX_VISIBILITY_FEATURE);
      const result = await resendRecord(recipient, guarded ? { retryOnUnavailable: false } : {});
      if (result && result.error && result.response && result.response.status === 409) {
        const serverMessage = result.response.data && result.response.data.error;
        this.setState({ conflictMessage: serverMessage || 'This fax is still being sent. Try again later.' });
        return;
      }
      if (source === 'status') {
        this.props.hideModal();
        if (result && result.error) return;
        if (onResent) {
          onResent(this.resentSendToken(recipient, result));
        } else {
          this.refreshStatusPage(recipient, result);
        }
        return;
      }
    }
    if (!this.props.error) {
      this.context.router.history.push('/app/sent');
    }
    this.props.hideModal();
  }

  // A resend from the status page stays there and reloads it; the resend can issue
  // a new send token, so follow it.
  resentSendToken = (recipient, result) => {
    const sentRow = result && result.data && result.data.sent_data && result.data.sent_data[0];
    return (sentRow && sentRow.send_token) || recipient.send_token;
  };

  refreshStatusPage = (recipient, result) => {
    const sendToken = this.resentSendToken(recipient, result);
    const statusPath = `/app/records/status/record/${recipient.file_token}/receiver/${sendToken}`;
    if (sendToken !== recipient.send_token) this.context.router.history.replace(statusPath);
    this.props.getStatusOfSentRecordById(recipient.file_token, sendToken);
  };

  modalMessage = () => {
    const { isLoading } = this.props;
    const { recipient } = this.state.params;
    const { conflictMessage } = this.state;
    if (conflictMessage) {
      return (<span role="alert">{conflictMessage}</span>);
    }
    if (isLoading) {
      return (<span> Resending, Please wait... </span>);
    }
    if (!this.props.isBulkResend) {
      return (
        <span style={{ fontWeight: '600' }}>
          Are you sure you want to resend this record?
          <br /><br />
          <span style={{ fontWeight: '300' }}>
            {
              `The selected record will be resent to  ${recipient.receiver_name
                || recipient.receiver_email
                || `fax number ${recipient.receiver_fax}`}.`
            }
          </span>
        </span>
      );
    } return (
      <span style={{ fontWeight: '600' }}>
        Are you sure you want to do a bulk resend?
        <br /><br />
        <span style={{ fontWeight: '300' }}>
          {`All records sent before today and have not been viewed in the past ${this.state.params.days} days will be resent.`}
        </span>
      </span>
    );
  }

  dismissLabel = () => {
    if (this.props.isLoading) return '';
    return this.state.conflictMessage ? 'Close' : 'Cancel';
  };

  render() {
    const { isLoading } = this.props;
    const { conflictMessage } = this.state;
    const customContentStyle = {
      width: '25%',
    };
    return (
      <ModalWrapper
        hideModal={this.props.hideModal}
        action={this.resend}
        customContentStyle={customContentStyle}
        actionName={this.props.isBulkResend ? 'Resend Records' : 'Resend Record'}
        dismiss={this.dismissLabel()}
        disabled={isLoading || Boolean(conflictMessage)}
        modalTitle="Resend Record"
      >
        {this.modalMessage()}
      </ModalWrapper>
    );
  }
}

ResendRecord.contextTypes = {
  router: PropTypes.object.isRequired,
};

ResendRecord.propTypes = {
  bulkResend: PropTypes.func.isRequired,
  isBulkResend: PropTypes.bool.isRequired,
  resendRecord: PropTypes.func.isRequired,
  hideModal: PropTypes.func.isRequired,
  modalType: PropTypes.object.isRequired,
  error: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  getStatusOfSentRecordById: PropTypes.func,
};

ResendRecord.defaultProps = {
  getStatusOfSentRecordById: () => {},
};


export default connect(state => ({
  error: state.records.error,
  isLoading: state.records.isLoading,
}))(ResendRecord);
export { ResendRecord };
